/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-07 15:20:09
 * @LastEditTime: 2022-01-29 18:19:19
 * @LastEditors: zhao - 🍉
 * @Description: 平台对账
 * @FilePath: /zhzj-admin/src/page/PlatformAccountingRecord/index.jsx
 */
import { Tabs } from 'antd'
import React from 'react'
import PageWrap from '../../components/PageWrap'
import MerchantList from './merchant'
import RuleList from './rule'


const HsbMarketPlatform = (props) => {

    return (
        <PageWrap>
            <Tabs animated={false}>
                <Tabs.TabPane key={1} tab="惠市宝市场商户信息" >
                    <MerchantList />
                </Tabs.TabPane>
                <Tabs.TabPane key={2} tab="惠市宝市场分账规则"  >
                    <RuleList />
                </Tabs.TabPane>
            </Tabs>
        </PageWrap>
    )
}

export default HsbMarketPlatform


// WEBPACK FOOTER //
// ./src/page/HsbMarketPlatform/index.jsx